import { IconSvgProps } from "@/types";

export default function LinkIcon2({
  size = 24,
  width,
  height,
  ...props
}: IconSvgProps) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      height={size || height}
      viewBox="0 0 20 20"
      width={size || width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.29672 1.52701L18.5939 1.52701M18.5939 1.52701L18.5939 12.8242M18.5939 1.52701L1.64813 18.4728"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}
